import React, { useImperativeHandle, forwardRef, useState } from 'react'
import PrimeModal from '@/components/primeModal'
import { useTranslation } from 'react-i18next'
import { Form, Input, App } from 'antd'

interface EditModalProps {
  onSubmit: (values: any) => void
}
const EditModal = ({ onSubmit }: EditModalProps, ref: any) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const [visible, setVisible] = useState(false)
  const [title, setTitle] = useState('')
  const { message } = App.useApp()

  const open = (record: any, extra: any) => {
    form.setFieldsValue(record)
    if (extra?.title) {
      setTitle(extra.title)
    }
    setVisible(true)
  }
  const close = () => {
    form.resetFields()
    setVisible(false)
  }

  useImperativeHandle(ref, () => ({
    open,
    close,
  }))

  const onFinish = async (values: any) => {
    if (typeof onSubmit === 'function') {
      await onSubmit(values)
      close()
      message.success(t('ikg.success', { action: title }))
    }
  }
  return (
    <PrimeModal
      open={visible}
      title={title}
      onCancel={close}
      onOk={() => form.submit()}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label={t('dict.name')}
          name="name"
          rules={[
            {
              required: true,
              message: t('ikg.input', { name: t('dict.name') }),
            },
          ]}
        >
          <Input placeholder={t('ikg.input', { name: t('dict.name') })} />
        </Form.Item>
        <Form.Item label={t('dict.code')} name="code">
          <Input placeholder={t('ikg.input', { name: t('dict.code') })} />
        </Form.Item>

        <Form.Item hidden name="parentId">
          <Input />
        </Form.Item>
        <Form.Item hidden name="directoryId">
          <Input />
        </Form.Item>
      </Form>
    </PrimeModal>
  )
}

export default forwardRef(EditModal)
